<div class="step-title">Choose membership type</div>
<div class="step-description">Transparent pricing, no hidden fees, no contracts.</div>

<div [formGroup]="form">
  <div class="btn-group-vertical" role="group" aria-label="Vertical button group">
     <ng-container *ngFor="let plan of planList; let i = index">
      <div class="row membership-plan">
        <div class="col-1 align-self-center">
            <input
              class="form-check-input form-check-input--paybee"
              type="radio"
              name="flexRadioDefault"
              [checked]="i === form.value.plans"
              [value]="plan.planType"
              (change)="onChange(plan.planType)"
            />
        </div>
        <div class="col-11">
          <div
            class="row align-items-center ml-2 ml-md-0 membership-container type-{{ plan.planType }}"
            [ngClass]="{'selected': this.selected?.planType === plan.planType}"
          >
            <div class='col-12'>
              <div class="row">
                <div class="col-6 type-name" [innerText]="plan.title"></div>
                <div class="col-6 type-price text-right">
                  <div class='actual-price' [innerText]="'$' + plan.invoiceAmount"></div>
                  <div class='default-price' *ngIf="coupons.length !== 0" [innerText]="'$' + plan.defaultInvoiceAmount"></div>
                </div>
              </div>
            </div>

            <div class="col-9">
              <div class="type-description" [innerHtml]="plan.description"></div>
            </div>

            <div class="col-3 align-self-start text-right">
              <div class="fee-info" *ngIf="plan.planType !== 0"> One-Time Onboarding Fee </div>
              <div class="fee-info"> 2% PayBee Fee + CC Processing Fee Apply </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="row promo-code">
    <div class="col-1"></div>
    <div class="col-5">
      <mdb-form-control class="form-fill mt-3" >
        <app-mdbp-input mdbInput  (keyup.enter)="onRedeemCoupon()" formControlName="code"  label='Enter Promo Code' [showMaxLength]="false"  maxLength="32"></app-mdbp-input>
    </mdb-form-control>

      <div class="mat-form-field-description mb-3 pr-5">
        <div class="mat-error">{{ getCouponErrorMessage() }}</div>
        <div class="opacity-50">Coupon code is case sensitive</div>
      </div>
    </div>
    <div class="col-6">
      <button class="action-button btn btn--paybee btn--cancel mt-4" (click)="onRedeemCoupon()"> Redeem </button>
    </div>
  </div>

  <div class="row justify-content-end mt-2">
    <div class="col-12 col-sm-4 col-lg-2">
      <button [ngClass]="nextBtnClasses" class="action-button btn btn--paybee btn--purple w-100" (click)="onNext()"> Next </button>
    </div>
  </div>


</div>
